import { SxProps, styled } from '@mui/material'
import { TBetOperator } from '@pturf-betin/betin-models-lib'
import { FlexBox, LazyImage } from 'components/atoms'
import { buildImgUrl } from 'utils'

export const LazyOperatorLogo = styled(LazyImage)(({ width = 52 }) => ({
    height: `${+width! * 0.46}px !important`,
    maxWidth: `${width}px`
}))

export const OperatorLogo = ({
    operator,
    size = 52,
    sx = {}
}: {
    operator: TBetOperator
    size?: number
    sx?: SxProps
}) => (
    <FlexBox data-testid="operator-logo" data-operator={operator.toUpperCase()}>
        <LazyOperatorLogo
            height={size * 0.46}
            width={size}
            src={buildImgUrl(
                `operator/${operator.toUpperCase()}/logo${operator === 'PMU' ? '-pmu-plus' : ''}.svg`
            )}
            alt="operator logo"
            style={{ verticalAlign: 'unset' }}
            sx={{ ...sx }}
        />
    </FlexBox>
)

export const OperatorBetType = ({
    operator,
    betType,
    big = false,
    size
}: {
    operator: TBetOperator | string
    betType: string
    big?: boolean
    size?: number
}) => {
    const style = {
        height:
            size ||
            (big &&
            operator === 'GENYBET' &&
            ['CO', 'TRO', 'S4', 'TRIO_ORDRE'].includes(betType)
                ? 29 * 1.25
                : big
                  ? 18 * 1.25
                  : 15 * 1.25),
        width: 'auto'
    }

    return (
        <LazyImage
            wrapperProps={{ style }}
            style={style}
            height="100%"
            width="100%"
            src={buildImgUrl(
                `operator/${operator.toUpperCase()}/bet-type/pari${
                    big ? '-big' : ''
                }-${betType}.svg`
            )}
            alt="bet type"
        />
    )
}
